// let initState = {};

// export const UserReducer = (state = initState, action) => {
//   const { type, payload } = action; //object destructring
//   switch (type) {
//     case "GETUSER":
//       return {
//         ...state,
//         GetUserAll: payload,
//       };
//     case "USER_REWARD":

//       return {
//         ...state,
//         reward: payload,
//       };

//     default:
//       return state;
//   }
// };

let initState = {};

export const ChartReducer = (state = initState, action) => {
  const { type, payload } = action; //object destructring
  switch (type) {
    case "CHART_DATA":
      return {
        ...state,
        data: payload,
      };
    case "ADD_USER":
      return {
        ...state,
        user: payload,
      };
    case "REMOVE_USER":
      return {
        ...state,
        user: payload,
      };

    default:
      return state;
  }
};

export const UserReducer = (state = { users: [] }, action) => {
  const { type, payload } = action;
  switch (type) {
    case "GOLDEN_USERS":
      return {
        ...state,
        users: payload,
      };
    default:
      return state;
  }
};
